import $ from 'jquery';
import React, { PropTypes } from 'react';
import ReactDOMServer from 'react-dom/server';
import { getCustomersWithoutContact } from './api';

// import Cookies from 'js-cookie';

// const COOKIES_STORE_KEY = 'liphatech.confirm';

export default function bind() {}

const content = names => {
  if (names.length === 1) {
    return `Le client ${
      names[0]
    } n'a pas de mail de contact. Êtes-vous sûr de vouloir lancer l'émission?`;
  } else {
    return `Les clients ${names.join(
      ', '
    )} n'ont pas de mail de contact. Êtes-vous sûr de vouloir lancer l'émission?`;
  }
};

export const displayConfirmModalIfNeeded = (ids, callback) => {
  const title = 'Mail de contact manquant';

  if (ids && ids.length > 0) {
    getCustomersWithoutContact(ids).then(response => {
      if (response.length > 0) {
        displayConfirmModal(title, content(response), callback);
      } else {
        callback();
      }
    });
  } else {
    callback();
  }
};

function displayConfirmModal(title, content, callback) {
  // Display modal
  const modal = ReactDOMServer.renderToStaticMarkup(
    <ConfirmModal title={title} content={content} />
  );

  // Appending content to body
  $(document.body).append(modal);

  // Handling approve button
  const $modal = $('#confirm-action-modal');
  $modal
    .modal({
      onApprove: element => {
        // Execute action and hiding it on executed
        callback();

        return true;
      },
    })
    .modal('show');
}

const ConfirmModal = ({ title, content }) => (
  <div id="confirm-action-modal" className="ui small modal">
    <div className="header">
      <i className="icon warning circle" />
      {title}
    </div>
    <div className="content" style={{ marginBottom: '20px' }}>
      <p>{content}</p>
    </div>
    <div className="actions">
      <div className="ui primary approve button">Confirmer</div>
      <div className="ui cancel button">Annuler</div>
    </div>
  </div>
);

ConfirmModal.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/saas/invoices/emit/confirm-emission.js